import type { ReactNode } from 'react';
import { LanguageSwitcher } from '@/components/layout/LanguageSwitcher';
import { ThemeSwitcher } from '@/components/layout/ThemeSwitcher';

interface AuthCardProps {
  title: string;
  description?: string;
  /** Kept for call-site compatibility; tabs are not used in U137 auth (B01-A03). */
  showTabs?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthCard = ({ title, description, children, footer }: AuthCardProps) => (
  <div className="auth-card u137-card">
    <div className="auth-toolbar">
      <LanguageSwitcher />
      <ThemeSwitcher />
    </div>

    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {children}
    {footer}
  </div>
);
